module.exports = __webpack_public_path__ + "img/arrow_left.f70d0a7a.svg";